export const API_BASE_URL = 'https://dummyjson.com';
export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCTS_BY_ID: '/products/',
  CATEGORIES: '/products/category-list',
  CATEGORY: 'products/category/',
  SEARCH: '/products/search',
};
export const ITEMS_PER_PAGE = 12;
export const STATE = {
  QUERY: '',
  PAGE: 1,
};


